import { render } from "./QuestionMCQ.vue?vue&type=template&id=4fbfb11a"
import script from "./QuestionMCQ.vue?vue&type=script&lang=js"
export * from "./QuestionMCQ.vue?vue&type=script&lang=js"

import "./QuestionMCQ.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__